import { useNodesData, Handle, Position, useReactFlow, useUpdateNodeInternals } from "@xyflow/react";
import { usePipelineBuilder } from "V2.0/HomePages/Pipelines/PipelineBuilder/PipelineBuilderProvider";
import { ConditionalRuleMode, TConditionalNode } from "../Models/Conditional";
import { validateNodeConfig } from "../NodeConfigure/nodeValidation";
import {
  Node,
  NodeActions,
  NodeBadge,
  NodeBody,
  NodeHeader,
  NodeName,
  NodePorts,
} from "./Components/Node";
import AddStepAction from "./Components/AddStepAction";
import ConfigureStepAction from "./Components/ConfigureStepAction";
import DeleteStepAction from "./Components/DeleteStepAction";
import { NodeUIRegistry } from "../Models/nodeUIRegistry";
import { NodeType } from "../Models/NodeType";
import NodeExecutionStatusBadge from "./Components/NodeExecutionStatus";
import useNodeExecution from "./Hooks/useNodeExecution";
import usePipelineNode from "./Hooks/usePipelineNode";
import { useEffect, useMemo } from "react";

export default ConditionalNode;

function ConditionalNode(props) {
  const { id } = props;
  const { setEdges } = useReactFlow();
  const updateNodeInternals = useUpdateNodeInternals();

  const {
    data,
    onDelete,
    handleAdd,
    isExecuted,
    internalNode,
    isPanelActive,
    isPreviewMode,
    onConfigureNode,
    executedNodeStatus,
  } = usePipelineNode<TConditionalNode>(id);

  const {
    label,
    color,
    icon: Icon,
  } = NodeUIRegistry[NodeType.CONDITIONAL][data.mode];

  const ports = useMemo(() => {
    return data.mode === ConditionalRuleMode.RULES
      ? [...data.rules.map((rule) => rule.outputPort), "default"]
      : ["default"];
  }, [data]);

  useEffect(() => {
    setTimeout(() => {
      updateNodeInternals(id);
    }, 0);
  }, [ports.join(","), updateNodeInternals]);

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
      />
      <Node status={executedNodeStatus}>
        <NodeHeader>
          <NodeBadge
            color={color}
            label={label}
            icon={<Icon className="size-4" />}
          />
          <NodeActions hideActions={isPanelActive}>
            {!isPreviewMode && <AddStepAction onAddStep={handleAdd} />}
            {(!isPreviewMode || isExecuted) && (
              <ConfigureStepAction
                onConfigureStep={() => onConfigureNode(internalNode)}
              />
            )}

            {!isPreviewMode && (
              <DeleteStepAction onDeleteStep={() => onDelete(internalNode)} />
            )}
          </NodeActions>
        </NodeHeader>
        <NodeBody>
          <NodeName name={data.name} />
          {isExecuted && (
            <NodeExecutionStatusBadge status={executedNodeStatus} />
          )}
        </NodeBody>
      </Node>
      <NodePorts ports={ports} />
    </>
  );
}
